module.exports = __webpack_public_path__ + "fonts/fa-regular-400.be09513.ttf";